<template>
  <v-card flat>
    <v-form v-model="valid" ref="updateForm" :disabled="submitLoading">
      <label>{{ $t('companiesDetails.name') }}</label>
      <v-text-field v-model="document.description" outlined dense :rules="required" />
      <v-radio-group v-model="validOptions" class="w-50">
        <v-radio :value="0">
          <template v-slot:label>
            <span>{{ $t('companiesDetails.indefinitely') }}</span>
          </template>
        </v-radio>
        <v-radio :value="1">
          <template v-slot:label>
            <v-menu v-model="validToMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="validTo" label="data" append-icon="$calendar" readonly dense outlined single-line hide-details :disabled="validIndefinitely()" v-bind="attrs" v-on="on" />
              </template>
              <v-date-picker
                v-model="validTo"
                :first-day-of-week="1"
                @input="validToMenu = false"
              />
            </v-menu>
          </template>
        </v-radio>
      </v-radio-group>
      <div class="d-flex flex-column">
        <div v-for="file in document.files" :key="file.name" class="d-flex align-center mb-2">
          <h4>{{ fileName(file.name) }}</h4>
          <v-icon class="ml-4 pointer" small @click="getFile(file)">$download</v-icon>
        </div>
        <div>
          <v-btn color="primary" :disabled="loading" @click="removeDocument" outlined>
            {{ $t('companiesDetails.delete') }}
          </v-btn>
        </div>
      </div>
      <div class="d-flex">
        <v-spacer />
        <v-btn color="primary" outlined :disabled="loading" :loading="loading" @click="updateDocument(document)">
          {{ $t('companiesDetails.updateDoc') }}
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import Service from '@/services'
import { dateFormat2, downloadFile } from '@/utils/helpers'

export default {
  name: 'TSLDocumentItem',
  props: {
    document: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    contractorId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      validToMenu: false,
      valid: true,
      submitLoading: false,
      required: [
        (v) => (!!v && !!v.trim()) || this.$t('validation.fieldRequired')
      ],
      validOptions: 0
    }
  },
  computed: {
    validTo: {
      get () {
        return dateFormat2(this.document.validTo)
      },
      set (newValue) {
        this.document.validTo = newValue
      }
    }
  },
  methods: {
    fileName (name) {
      var length = name.length
      if (length > 40) {
        return name.slice(0, 20) + '...' + name.slice(length - 10, length)
      }
      return name
    },
    updateDocument (document) {
      this.$refs.updateForm.validate()
      if (!this.valid) {
        return
      }
      this.$emit('update', {
        contractorId: this.contractorId,
        documentId: document.id,
        description: document.description,
        validIndefinitely: this.validIndefinitely(),
        validTo: document.validTo
      })
    },
    removeDocument () {
      this.$emit('remove', this.document.id)
    },
    async getFile (file) {
      try {
        const fileName = file.name
        const url = `/TSLContractor/GetDocumentFile?contractorId=${this.contractorId}&documentId=${this.document.id}&fileName=${encodeURIComponent(fileName)}`
        const { data } = await Service.getFile(url)
        downloadFile(file, data)
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error downloading file')
      }
    },
    validIndefinitely () {
      return this.validOptions === 0
    }
  },
  mounted () {
    if (this.document.validIndefinitely) {
      this.validOptions = 0
    } else {
      this.validOptions = 1
    }
  }
}
</script>
